import { users } from './state';

export function renderUsers(): void {
    const list = document.getElementById('userList');
    if (!list) return;

    list.innerHTML = '';

    const note = document.createElement('div');
    note.className = 'text-muted small mb-2';
    note.innerHTML =
        '<i class="ti ti-info-circle me-1"></i> Team members are managed in your Members account. This list is read-only.';
    list.appendChild(note);

    if (users.length === 0) {
        list.insertAdjacentHTML(
            'beforeend',
            '<div class="list-group-item text-muted">No users loaded yet.</div>',
        );
        return;
    }

    users.forEach((user) => {
        const item = document.createElement('div');
        item.className = 'list-group-item';
        item.innerHTML = `
            <div class="d-flex align-items-start">
                <div class="flex-grow-1">
                    <div class="fw-semibold"><i class="ti ti-user me-2"></i> ${user.name}</div>
                    <div class="text-muted small">${user.email}</div>
                    <div class="badge bg-secondary-lt mt-2">${user.role}</div>
                </div>
            </div>
        `;
        list.appendChild(item);
    });
}
